import { QUIZ_URL } from "../../constants";
import { apiSlice } from "../apiSlice";

const quizSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuiz: builder.query({
      query: (quizParams) => ({
        url: `${QUIZ_URL}?topic=${quizParams.topic}&level=${quizParams.level}&number=${quizParams.number}&model=${quizParams.model}&_id=${quizParams._id}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getAllQuizzes : builder.query({
      query: () => ({
        url: `${QUIZ_URL}/all`,
      }),
      keepUnusedDataFor: 5,
    }),
    getOpenQuizzes : builder.query({
      query: (id) => ({
        url: `${QUIZ_URL}/open`,
      }),
      keepUnusedDataFor: 5,
    }),
    getQuizById: builder.query({
      query: (id) => ({
        url: `${QUIZ_URL}/id/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),
    rateQuiz: builder.mutation({
      query: (data) => ({
        url: QUIZ_URL,
        method: 'POST',
        body: data,
      })
    }),
  }),
});

export const { 
  useLazyGetQuizQuery,
  useGetAllQuizzesQuery,
  useLazyGetOpenQuizzesQuery, 
  useLazyGetQuizByIdQuery,
  useRateQuizMutation, } = quizSlice;